/**
 * Privacy-First Local Remedy & Consultation Diary.
 *
 * Saves prescribed Vedic remedies, mantras, gemstones, and past AI consultations
 * locally on the seeker's device so they can track spiritual practices over time.
 */

export interface SavedRemedyItem {
  id: string;
  title: string;
  category: "mantra" | "gemstone" | "pooja" | "charity" | "fasting";
  description: string;
  prescribedFor: string; // e.g. "Shani Sade Sati" or "Jupiter Mahadasha"
  addedAt: number;
  isCompleted?: boolean;
}

const REMEDY_STORAGE_KEY = "ishvaram_remedy_diary_v1";

export function getSavedRemedies(): SavedRemedyItem[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(REMEDY_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/** @internal */
export function saveRemedy(item: Omit<SavedRemedyItem, "id" | "addedAt">): SavedRemedyItem {
  const existing = getSavedRemedies();
  const newItem: SavedRemedyItem = {
    ...item,
    id: `remedy_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`,
    addedAt: Date.now(),
    isCompleted: false,
  };

  try {
    window.localStorage.setItem(REMEDY_STORAGE_KEY, JSON.stringify([newItem, ...existing]));
  } catch {
    // Non-blocking
  }

  return newItem;
}

export function deleteRemedy(id: string): void {
  const existing = getSavedRemedies();
  const updated = existing.filter((r) => r.id !== id);
  try {
    window.localStorage.setItem(REMEDY_STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // Non-blocking
  }
}

export function toggleRemedyCompleted(id: string): void {
  const existing = getSavedRemedies();
  const updated = existing.map((r) => (r.id === id ? { ...r, isCompleted: !r.isCompleted } : r));
  try {
    window.localStorage.setItem(REMEDY_STORAGE_KEY, JSON.stringify(updated));
  } catch {
    // Non-blocking
  }
}
